import React from "react";
import { merchantCategoriesGlobal } from "../../../../utils/merchCategoriesGlobal";
import "../styles/ActivityLog.css";

const ActivityLog = ({ activityData }) => {
  if (!activityData || Object.keys(activityData).length === 0) {
    return <div className="no-activity">No activity logs yet.</div>;
  }

  return (
    <div className="activity-log-container">
      {Object.keys(activityData).map((date, i) => (
        <div key={i} className="activity-date-group">
          <div className="activity-date-header">
            <div className="activity-date">{date}</div>
          </div>
          <div className="activity-entries">
            {activityData[date].map((log, index) => (
              <div key={index} className="activity-entry">
                <div className="activity-time">{log.time} :</div>
                <div className="activity-content">
                  <div
                    className={`activity-message ${getActivityTypeClass(
                      log.activityLogType
                    )}`}
                  >
                    {formatActivityMessage(log)}
                  </div>

                  {log.activityLogType === "PROFILE_UPDATED" &&
                    log.details?.changeDetails &&
                    Object.keys(log.details.changeDetails).length > 0 && (
                      <div className="changes-list">
                        {Object.keys(log.details.changeDetails).map(
                          (field, fieldIndex) => {
                            const change = log.details.changeDetails[field];
                            return (
                              <div key={fieldIndex} className="change-item">
                                <div className="change-field">
                                  • {formatFieldName(field)}:
                                </div>

                                {field === "category" ? (
                                  <div className="change-values">
                                    <div className="old-value">
                                      Previous:{" "}
                                      {renderCategories(
                                        change.previousValue,
                                        change.newValue
                                      )}
                                    </div>
                                    <div className="new-value">
                                      New:{" "}
                                      {renderCategories(
                                        change.newValue,
                                        change.previousValue
                                      )}
                                    </div>
                                    {renderCategoryChanges(
                                      change.previousValue,
                                      change.newValue
                                    )}
                                  </div>
                                ) : field === "projectUrls" ? (
                                  <div className="change-values">
                                    <div className="old-value">
                                      Previous images count:{" "}
                                      {change.previousValue?.length || 0}
                                    </div>
                                    <div className="new-value">
                                      New images count:{" "}
                                      {change.newValue?.length || 0}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="change-values">
                                    <div className="old-value">
                                      Previous: {change.previousValue || "None"}
                                    </div>
                                    <div className="new-value">
                                      New: {change.newValue || "None"}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}

                  {log.activityLogType === "MERCH_PROFILE_DECLINED" &&
                    log.details?.reason && (
                      <div className="decline-reason">
                        <strong>Reason:</strong> {log.details.reason}
                      </div>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

const formatActivityMessage = log => {
  switch (log.activityLogType) {
    case "PROFILE_UPDATED":
      const changedFields = log.details?.changeDetails
        ? Object.keys(log.details.changeDetails).length
        : 0;
      return `Merchant updated profile${
        changedFields > 0
          ? ` (${changedFields} field${changedFields > 1 ? "s" : ""} changed)`
          : ""
      }`;

    case "MERCH_PROFILE_DECLINED":
      return "Admin declined the profile";

    case "PROFILE_UNDER_REVIEW":
      return "Merchant submitted profile for review";

    default:
      return log.message || `Activity: ${log.activityLogType}`;
  }
};

const formatFieldName = field => {
  // Convert camelCase or snake_case to Title Case with spaces
  return field
    .replace(/([A-Z])/g, " $1") // Insert a space before all capital letters
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/^\w/, c => c.toUpperCase()); // Capitalize the first letter
};

const getActivityTypeClass = activityType => {
  switch (activityType) {
    case "PROFILE_UPDATED":
      return "activity-update";
    case "MERCH_PROFILE_DECLINED":
      return "activity-decline";
    case "PROFILE_UNDER_REVIEW":
      return "activity-review";
    default:
      return "";
  }
};

const renderCategories = (categoryIds, otherCategoryIds = []) => {
  if (!categoryIds || categoryIds.length === 0) {
    return "None";
  }

  const ENV =
    process.env.REACT_APP_APP_CONFIG !== "production" ? "DEV" : "PROD";

  return (
    <ul className="category-list">
      {categoryIds.map((categoryId, index) => {
        const categoryInfo = merchantCategoriesGlobal[ENV][categoryId];
        const isChanged = !otherCategoryIds.includes(categoryId);
        return (
          <li key={index} className={isChanged ? "changed-category" : ""}>
            {categoryInfo?.name || "Unknown category"}
            {isChanged && <span className="category-indicator"></span>}
          </li>
        );
      })}
    </ul>
  );
};

const renderCategoryChanges = (previousValue, newValue) => {
  const addedCategories = newValue.filter(id => !previousValue.includes(id));
  const removedCategories = previousValue.filter(id => !newValue.includes(id));

  if (addedCategories.length > 0 || removedCategories.length > 0) {
    return (
      <div className="category-changes">
        {addedCategories.length > 0 && (
          <span className="added-categories">
            +{addedCategories.length} new category
            {addedCategories.length > 1 ? "s" : ""}
          </span>
        )}
        {removedCategories.length > 0 && (
          <span className="removed-categories">
            -{removedCategories.length} category
            {removedCategories.length > 1 ? "s" : ""}
          </span>
        )}
      </div>
    );
  }
  return null;
};

export default ActivityLog;
